<div class="dialog-wrapper">
  <p class="emoji-gift-cone">😔</p>
  <h1 class="welcome-text">Sorry !</h1>
  <p class="congrats-text">Games are designed for mobile devices only. Please use a mobile to play.</p>
  <ion-button expand="block" color="medium" class="capsule-btn" (click)="close()"> Try on mobile </ion-button>
</div>
